import React from "react";
import SectionHero from "../../sections/SectionHero";
import MainLayout from "../../layout/MainLayout";

const HomePage = () => {
  return (
    <MainLayout>
      <SectionHero />
    </MainLayout>
  );
};

export default HomePage;
